import type { FC } from "react";
import type { PhraseValues } from "./replaceVariables";
import resolvePhrase from "./resolvePhrase";
import type { CmsPhrase as CmsPhraseType } from "./types";

type Props = {
  phrase?: CmsPhraseType | null;
  brandSlug: string;
  values?: PhraseValues;
  className?: string;
};

// Renders a resolved CMS Phrase (brand overwrite + `{placeholder}` substitution
// handled by resolvePhrase), tagging the element with its key for tooling. The
// single place all apps render a phrase, so presentation changes broadcast here.
const CmsPhrase: FC<Props> = ({ phrase, brandSlug, values, className }) => {
  if (!phrase) {
    return null;
  }
  return (
    <span data-cms-phrase={phrase.key} className={className}>
      {resolvePhrase(brandSlug, phrase, values)}
    </span>
  );
};

export default CmsPhrase;
